import { Flex, Select, Typography } from "antd";
import { Dispatch, FC, ReactNode, SetStateAction } from "react";
import { Filter } from "../../Filter";
import "./index.less";

export interface CustomerPageFilterProps {
  id: number;
  name: string;
  onClick: () => void;
}

interface CustomerPageWrapperProps {
  title: string;
  filters?: CustomerPageFilterProps[];
  children: ReactNode;
  activeFilter?: number;
  selectFilters?: { value: string | undefined; label: string | null | undefined }[] | undefined;
  selectActiveFilter?: string[];
  setSelectFilter?: Dispatch<SetStateAction<string[]>>;
  showSelect?: boolean;
}

export const CustomerPageWrapper: FC<CustomerPageWrapperProps> = ({
  title,
  filters,
  activeFilter,
  selectFilters,
  selectActiveFilter,
  children,
  setSelectFilter,
  showSelect = false,
}) => {
  return (
    <Flex vertical>
      <Flex justify="space-between" align="center">
        <Typography.Title level={3} className="header-title">
          {title}
        </Typography.Title>
        <Flex className="filter-list">{filters?.map((f) => <Filter isActive={activeFilter === f.id} key={f.name} {...f} />)}</Flex>

        {showSelect && (
          <Flex>
            <Select
              mode="multiple"
              options={[
                ...(selectFilters?.filter((c) => selectActiveFilter?.includes(String(c.value))) || []),
                ...(selectFilters?.filter((c) => !selectActiveFilter?.includes(String(c.value))) || []),
              ]}
              value={selectActiveFilter}
              placeholder="All Categories"
              onChange={(e) => setSelectFilter && setSelectFilter(e)}
              className="category-filter"
              classNames={{ popup: { root: "popup-class-name" } }}
            />
          </Flex>
        )}
      </Flex>
      {children}
    </Flex>
  );
};
